export { ProductCatd } from "./ui.tsx";
